import { render } from "./SendDataConformationPopup.vue?vue&type=template&id=28dabb3f&scoped=true"
import script from "./SendDataConformationPopup.vue?vue&type=script&lang=js"
export * from "./SendDataConformationPopup.vue?vue&type=script&lang=js"

import "./SendDataConformationPopup.vue?vue&type=style&index=0&id=28dabb3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28dabb3f"]])

export default __exports__